import { defineRouting } from 'next-intl/routing'

export const locales = ['en', 'de', 'nl', 'ar'] as const
export type Locale = (typeof locales)[number]
export const localePrefix = 'as-needed' // 'as-needed' 'always' 'never'
export const defaultLocale: Locale = 'en'

export const routing = defineRouting({
  locales,
  defaultLocale,
  localePrefix,
})
